/**
 * RISK-LOG-1 — score is probability × impact. The band is calculated.
 * 17–19 cannot occur on a 5×5 grid; if a score arrives anyway it stays High.
 */
export type RiskBand = "Low" | "Medium" | "High" | "Critical";

export function riskScore(probability: number, impact: number): number | null {
  if (!Number.isInteger(probability) || !Number.isInteger(impact)) return null;
  if (probability < 1 || probability > 5 || impact < 1 || impact > 5) return null;
  return probability * impact;
}

export function riskBand(score: number): RiskBand | null {
  if (!Number.isInteger(score) || score < 1 || score > 25) return null;
  if (score >= 20) return "Critical";
  if (score >= 10) return "High";
  if (score >= 5) return "Medium";
  return "Low";
}

export const RISK_BAND_TOKEN: Record<RiskBand, string> = {
  Low: "var(--zx-risk-low)",
  Medium: "var(--zx-risk-medium)",
  High: "var(--zx-risk-high)",
  Critical: "var(--zx-risk-critical)",
};
